module.exports = __webpack_public_path__ + "img/big-money.d43767b5.png";